import { UserResultRadarGraph } from '@orientaction/components';
import { Chart } from 'chart.js';
import { harmonyPalette } from '../content/harmonyPresentation';

// Scope the palette to Redesign charts while retaining the shared chart's
// sorting, translations, axes, average curve and responsive configuration.
Chart.register({
  id: 'redesignHarmonyPalette',
  beforeUpdate(chart) {
    if (chart.canvas.closest('[data-harmony-palette]')) {
      chart.data.datasets[0].backgroundColor = chart.data.datasets[0].data.map(
        (_, index) => harmonyPalette[index % harmonyPalette.length]
      );
    }
  },
});

const HarmonyResultChart = ({
  result,
  fromCompass = false,
  isEmpty = false,
}: {
  result: any;
  fromCompass?: boolean;
  isEmpty?: boolean;
}) => (
  <div data-harmony-palette="true" style={{ width: '100%', height: '100%' }}>
    <UserResultRadarGraph
      resultToShow={result}
      showAllLabels={true}
      fromCompass={fromCompass}
      isEmpty={isEmpty}
      canUserAccessHarmony={!isEmpty}
    />
  </div>
);

export default HarmonyResultChart;
